import { FeatureFlag } from 'types/features';
import { useFeatureFlags } from 'utils/useFeatureFlags';

interface BaseProps {
    action: 'show' | 'hide';
    children: JSX.Element;
}

interface SingleFlagProps extends BaseProps {
    flag: FeatureFlag;
    mode?: never;
}

interface MultipleFlagsProps extends BaseProps {
    flag: FeatureFlag[];
    mode: 'any' | 'all';
}

type Props = SingleFlagProps | MultipleFlagsProps;

const FeatureFlagged = ({ flag, action, children, mode }: Props): JSX.Element | null => {
    const { isFlowEnabled, isFlowDisabled } = useFeatureFlags(flag, mode && mode === 'all');

    if ((isFlowEnabled && action === 'hide') || (isFlowDisabled && action === 'show')) {
        return null;
    }

    return children;
};

export default FeatureFlagged;
